module.exports = __webpack_public_path__ + "static/img/logo76.c7a77c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo76.png
// module id = 4cAn
// module chunks = 1